export enum SearchPredicate {
  AND = 'AND',
  OR = 'OR'
}
